import { Box } from '@mui/material';

import { ClansResponse, Seasons } from '../providers/DataProvider.types';

import gold from '../assets/tournamentTable/position/gold.svg';
import silver from '../assets/tournamentTable/position/silver.svg';
import bronze from '../assets/tournamentTable/position/bronze.svg';
import position_gold from '../assets/common/positionMedals/gold.svg';
import position_silver from '../assets/common/positionMedals/silver.svg';
import position_bronze from '../assets/common/positionMedals/bronze.svg';

export const getClanImage = (name: string, clans: ClansResponse[] | undefined) => {
    return clans?.find((el) => el.clan === name)?.picture;
};

export const getPositionImage = (position: number) => {
    switch (position) {
        case 1: {
            return <img src={gold} alt="gold"></img>;
        }
        case 2: {
            return <img src={silver} alt="silver"></img>;
        }
        case 3: {
            return <img src={bronze} alt="bronze"></img>;
        }
        default: {
            return '#' + position;
        }
    }
};

export const getScoreboardPosition = (clans: ClansResponse[]) => {
    let scoreboardPosition = 1;
    let previousRank = 0;

    return clans
        .sort((a, b) => a.rank - b.rank)
        .map((clan, index) => {
            if (index === 0) {
                previousRank = clan.rank;
            } else if (clan.rank !== previousRank) {
                scoreboardPosition = index + 1;
                previousRank = clan.rank;
            }
            return {
                ...clan,
                scoreboardPosition,
            };
        });
};

export const getPositionMedal = (position: number, withoutBorder = false) => {
    switch (position) {
        case 1: {
            return <img src={position_gold} alt="gold"></img>;
        }
        case 2: {
            return <img src={position_silver} alt="silver"></img>;
        }
        case 3: {
            return <img src={position_bronze} alt="bronze"></img>;
        }
        default: {
            return (
                <Box
                    sx={{
                        border: withoutBorder ? 'none' : '1px solid rgba(178, 183, 190, 0.30)',
                        borderRadius: '50%',
                        height: '42px',
                        width: '42px',
                        color: '#9298A1',
                        fontFamily: 'AvenirNext400',
                        fontSize: '14px',
                        lineHeight: 'normal',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: 'auto',
                    }}
                >
                    {'#' + position}
                </Box>
            );
        }
    }
};

export function parseCSV(csvData: string): Seasons {
    const seasonLines = csvData.split('\n').map((line) => line.replace('\r', ''));
    return seasonLines.map((line) => {
        const values = line.split(';');
        return {
            name: values[0],
            color: values[1],
        };
    });
}

export const getSuffix = (i: number | undefined) => {
    if (!i) return i;
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
        return i + 'st';
    }
    if (j === 2 && k !== 12) {
        return i + 'nd';
    }
    if (j === 3 && k !== 13) {
        return i + 'rd';
    }
    return i + 'th';
};
